import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import WidgetHeader from './WidgetHeader'
import WidgetContent from './WidgetContent'

const Widget = ({ actions, children, className, header, info, ...props }) => (
  <div className={className} {...props}>
    <WidgetHeader
      info={info}
      actions={actions}
      header={header}
    />
    <WidgetContent>
      {children}
    </WidgetContent>
  </div>
)

Widget.propTypes = {
  actions: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  header: PropTypes.node,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default styled(Widget)`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`
